import { render } from "./AdminSortTable.vue?vue&type=template&id=2e6c211d&scoped=true"
import script from "./AdminSortTable.vue?vue&type=script&lang=js"
export * from "./AdminSortTable.vue?vue&type=script&lang=js"

import "./AdminSortTable.vue?vue&type=style&index=0&id=2e6c211d&scoped=true&lang=css"

import exportComponent from "/Users/zellwegv/repos-work/ce-365-spiral-curve/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6c211d"]])

export default __exports__